import { render } from "./ModalNuovaTodo.vue?vue&type=template&id=de0a489e&scoped=true"
import script from "./ModalNuovaTodo.vue?vue&type=script&lang=js"
export * from "./ModalNuovaTodo.vue?vue&type=script&lang=js"

import "./ModalNuovaTodo.vue?vue&type=style&index=0&id=de0a489e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0a489e"]])

export default __exports__